<template>
  <div class="ee-editor pa-2">
    <div class="v-label pb-2">{{ title }}</div>
    <v-chip
      v-for="(item, index) in items"
      :key="index"
      class="mt-2"
      :close="index == items.length - 1"
      @click="edit(item, index)"
      @click:close="remove(index)"
      >{{ item }}</v-chip
    >
    <v-chip @click="add" color="success" class="mt-2">
      <v-icon>mdi-plus</v-icon>
    </v-chip>

    <v-dialog v-model="dialog" width="400" scrollable>
      <v-card>
        <v-card-title>{{ dialogTitle }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-container>
            <v-row>
              <v-col cols="12">
                <FieldValuePickerBase
                  title="Value"
                  v-model="dataValue"
                  :table="table"
                  :component="component"
                  :containers="containers"
                  type="text"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="submit">OK</v-btn>
          <v-btn text color="error" @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FieldValuePickerBase from "./FieldValuePickerBase.vue";

export default {
  name: "TextEditor",

  components: { FieldValuePickerBase },

  props: ["title", "value", "table", "component", "containers"],

  data() {
    return {
      items: [],
      dialog: false,
      activeItemIndex: -1,
      dataValue: null,
      dialogTitle: null,
    };
  },

  watch: {
    value() {
      this.refresh();
    },
  },

  mounted() {
    this.refresh();
  },

  methods: {
    refresh() {
      if (this.value) {
        this.items = this.value.toString().split("|");
      } else {
        this.items = [];
      }
    },
    add() {
      this.activeItemIndex = -1;
      this.dataValue = null;
      this.dialogTitle = "Add";
      this.dialog = true;
    },
    edit(item, index) {
      this.activeItemIndex = index;
      this.dataValue = item;
      this.dialogTitle = "Edit";
      this.dialog = true;
    },
    submit() {
      if (this.activeItemIndex == -1) {
        this.items.push(this.dataValue);
      } else {
        this.items[this.activeItemIndex] = this.dataValue;
      }

      this.dialog = false;
      this.$emit("input", this.items.join("|"));
    },
    remove(index) {
      this.items.splice(index, 1);
      this.$emit("input", this.items.join("|"));
    },
  },
};
</script>

<style scoped>
.ee-editor {
  background: #fff;
  border: 1px solid #ccc;
}
</style>